export default function setValues({ state }, { mapViewId, values }) {
  const statePath = ['mapViewById', `${mapViewId}`];

  if (!state.exists(statePath)) {
    return;
  }

  const mapStateCursor = state.select(statePath);
  Object.keys(values).forEach((mapStateKey) => {
    mapStateCursor.set(mapStateKey, values[mapStateKey]);
  });

  state.commit();
}
